module.exports = __webpack_public_path__ + "img/404.f932f34c.svg";